module.exports = __webpack_public_path__ + "static/favicon-352380ff197e4d270f15ca4802c6aee5.ico";